//custom hook for password visibility
import { useState } from "react";
import { BiHide,BiShow } from "react-icons/bi";

export const usePasswordToggle = (initialState = false) => {
    const [isPasswordVisible, setPasswordVisible] = useState(initialState);
    const [eyeIcon, setEyeIcon ] = useState(<BiShow cursor={'pointer'} size={20}/>)

    const togglePasswordVisibility = () => {
      setPasswordVisible((prevState) => {
          const newState = !prevState;
          setEyeIcon(newState ? <BiHide cursor={'pointer'} size={20}/> : <BiShow cursor={'pointer'} size={20}/>);
          return newState;
      });
  };

    return [isPasswordVisible,eyeIcon, togglePasswordVisibility];
};